import "./ProgressLevel.scss";

const ProgressLevel = ({user}) => {
    const amoun = user.currentAmount - (5000 * Math.floor(user.currentAmount / 2500))
    const gg = amoun / 2500 * 100
    const percent = Math.max(0, Math.min(100, gg || 0))

    return (
        <div className="pb-progress">
            <div className="pb-progress-head">
                <span className="pb-muted">До наступного рівня</span>
                <span className="pb-progress-percent">{ Math.round(percent) }%</span>
            </div>
            <div className="pb-bar">
                <div className="pb-bar-fill" style={{ width: `${percent}%` }} />
            </div>
            <div className="pb-progress-labels">
                <span>{ amoun || 0 } UAH</span>
                <span>2500 UAH</span>
            </div>
        </div>
    );
};

export default ProgressLevel;
